export default __webpack_public_path__ + "static/media/logoFooter.556450db.png";